import { render } from "./media-slideshow.vue?vue&type=template&id=52317d3b"
import script from "./media-slideshow.vue?vue&type=script&lang=js"
export * from "./media-slideshow.vue?vue&type=script&lang=js"

import "./media-slideshow.vue?vue&type=style&index=0&id=52317d3b&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__